import React from 'react';

var RejectPopup = React.createClass({
	getInitialState: function(){
		return {rejection: {"unknown_person": false, 
							"not_intended_for_me": false,
							"do_not_want_it": false,
							"The material is offensive.": false}}
	},
	componentDidMount: function(){
		// $('.modal__content').css({'position': 'fixed'});
		if(!!this.props.data){
			this.setState({rejection: this.props.data});
		}
	},	
	handleCancelClick: function(){
		this.props.reject("close");
	},
	handleRejectClick: function(){
		this.props.reject("submit", this.state.rejection);
	},
	handleChange: function(name, e){
		var rejection = this.state.rejection;
		if(e.target.checked){
			rejection[name] = true;
		} else {
			rejection[name] = false;
		}
		this.setState({rejection: rejection});
	},
	handleOffensiveChange: function(name, e){
		this.props.reject("close");
		this.props.rejectOffensive("open", this.state.rejection);
	},	
	handleStopPropogation: function(e) {
		e.stopPropagation() 
	},
	render: function(){
		return (
			<div className="modal__mask" onClick = {this.handleCancelClick}>
				<div className="modal__content modal--md" onClick = {this.handleStopPropogation}>
				  <div className="modal__header">
				    <h3 className="modal__header--title">Why are you rejecting this package?</h3>
				    <a href="javascript:void(0)" className="modal__close" onClick = {this.handleCancelClick}><i className="fa  fa-close"> </i></a> </div>
				  <div className="modal__body clearfix">
				    <div className="form__row clearfix">
				      <ul className="reject__list list-unstyled">
				        <li className="reject__item checkbox">
				          <label htmlFor="a1">
				            <input  id="a1" name="check" type="checkbox" checked = {this.state.rejection["unknown_person"]} onChange = {this.handleChange.bind(this, "unknown_person")}/>
				            I don't know the person who shared this with me. </label>
				        </li>
				        <li className="reject__item checkbox">
				          <label htmlFor="a2">
				            <input id="a2" name="check" type="checkbox" checked = {this.state.rejection["not_intended_for_me"]} onChange = {this.handleChange.bind(this, "not_intended_for_me")}/>
				            It wasn't intended for me. </label>
				        </li>
				        <li className="reject__item checkbox">
				          <label htmlFor="a3">
				            <input id="a3" name="check" type="checkbox" checked = {this.state.rejection["do_not_want_it"]}  onChange = {this.handleChange.bind(this, "do_not_want_it")}/>
				            I don't want it; it's clogging up my list. </label>
				        </li>
				        <li className="reject__item checkbox">
				          <label htmlFor="a4">
				            <input id="a4" name="check" type="checkbox" checked = {this.state.rejection["The material is offensive."]} onChange = {this.handleOffensiveChange.bind(this,"The material is offensive.")}/>
				            The material is offensive. </label>
				        </li>
				      </ul>
				    </div>
				    <div className="buttons clearfix">
				      <button className="btn__lg bg-very_light" onClick = {this.handleCancelClick}>Cancel</button>
				      <button className="btn__lg bg-bold" onClick = {this.handleRejectClick}>Reject</button>
				    </div>
				  </div>
				</div>
			</div>
		);
	}
});

export {RejectPopup};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/RejectPopup.jsx
 **/